import keraltyLoader from "../../assets/keralty-loader.gif";
import styles from "./KeraltyLoader.module.css";

export const KeraltyLoader = () => {
  return (
    <div className={styles.loaderContainer}>
      <img src={keraltyLoader} alt="keralty-loader" />
    </div>
  );
};
